const languageSwitcher = () => {
  const $languageSwitcher = document.querySelector('.c-language-menu');
  if (!$languageSwitcher) return;
  const $languageSwitcherLinks = $languageSwitcher.querySelectorAll('.c-language-menu__link');
  $languageSwitcherLinks.forEach(linkElement => {
    const hrefValue = linkElement.getAttribute('href');
    const lastSlashIndex = hrefValue.endsWith('/filter');
    if (lastSlashIndex) {
      const newHref = hrefValue.replace(/filter$/, '');
      linkElement.setAttribute('href', newHref);
    }
  });
};
export default languageSwitcher;